import { useEffect } from 'react';
import '@n8n/chat/style.css';
import "../styles/Bot.scss";
import { createChat } from '@n8n/chat';

export const Bot = () => {
	useEffect(() => {
		createChat({
            webhookUrl: 'https://n8n-ovit-production.up.railway.app/webhook/bf3f4b35-b27d-4eda-a40a-f82c77aaa974/chat',
            webhookConfig: {
                method: 'POST',
                headers: {}
            },
            target: '#n8n-chat',
            mode: 'window',
            chatInputKey: 'chatInput',
            chatSessionKey: 'sessionId',
            metadata: {},
            showWelcomeScreen: false,
            defaultLanguage: 'en',
            initialMessages: [
                'Hola 👋 Soy tu asistente virtual. Escríbenos para cotizaciones o dudas. Estoy a la orden.😃',
            ],
            i18n: {
                en: {
                    title: '¡Bienvenido a Real Results!',
                    subtitle: "¿Listo para subir de nivel tu negocio? 💼 Te asesoro 24/7 en marketing digital.",
                    footer: '',
                    getStarted: 'New Conversation',
                    inputPlaceholder: 'Escribe tu pregunta..',
                },
            },
        });
	}, []);

	return (<div></div>);
};

export default Bot;